import httpClient from "@lab/api/httpClient";
import { Organisation } from "@lab/types/organisation";
import { User, OrganisationUser } from "@/shared/types/users";
import { Hospital } from "@/shared/types/hospitals";
import { Group } from "@/shared/types/groups";
import { Layout } from "@/shared/types/layouts";

export const users = {
	fetch: async (): Promise<User[] | undefined> => {
		const response = await httpClient.get(`/users/`);
		return response.data as User[];
	},
};

export const user = {
	config: {
		get: async (id: number) => {
			const response = await httpClient.get(`/users/${id}/config`);
			return response.data;
		},
	},
	create: async (user) => {
		const response = await httpClient.post(`/users`, user);
		return response.data;
	},
	dashboards: {
		get: async (id: number): Promise<Layout[] | undefined> => {
			const response = await httpClient.get(`/users/${id}/dashboards`);
			return response.data as Layout[];
		},
	},
	remove: async (id: number) => {
		const response = await httpClient.delete(`/users/${id}`);
		return response.data;
	},
	invite: async (id: number) => {
		const response = await httpClient.post(`/users/${id}/resendinvite`);
		return response.data;
	},
	fetch: async (id: number) => {
		const response = await httpClient.get(`/users/${id}`);
		return response.data;
	},
	update: async (user) => {
		const response = await httpClient.put(`/users/${user.id}`, user);
		return response.data;
	},
	updateStatus: async (id: number, status: "activate" | "deactivate") => {
		const response = await httpClient.post(`/users/${id}/${status}`);
		return response.data;
	},
	activate: async (id: number) => await user.updateStatus(id, "activate"),
	deactivate: async (id: number) => await user.updateStatus(id, "deactivate"),
	updateContact: async (id: number, status: "promote" | "demote") => {
		const response = await httpClient.post(
			`/admin/web/users/${id}/${status}`
		);
		return response.data;
	},
	promote: async (id: number) => await user.updateContact(id, "promote"),
	demote: async (id: number) => await user.updateContact(id, "demote"),
};

export const editor = {
	...user,
	listings: {
		get: async (id: number) => {
			const response = await httpClient.get(`/users/${id}/listings`);
			return response.data;
		},
	},
	listingContacts: {
		get: async (id: number) => {
			const res = await httpClient.get(`/users/${id}/listingcontacts`);
			return res.data || [];
		},
	},
	organisation: {
		get: async (id: number) => {
			const response = await httpClient.get(`/users/${id}/organisation`);
			return response.data;
		},
	},
};

export const connect = {
	...user,
	groups: {
		get: async (id: number): Promise<Group[] | undefined> => {
			const response = await httpClient.get(`/users/${id}/groups`);
			return response.data as Group[];
		},
	},
	hospital: {
		get: async (id: number): Promise<Hospital | undefined> => {
			const response = await httpClient.get(`/users/${id}/hospital`);
			return response.data as Hospital;
		},
	},
};
